export default __webpack_public_path__ + "static/statii-801064673eaa0ef5121ecbfa4b3f98d1.jpg";